"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Headphones = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Headphones = function Headphones(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.043 6.591l-.14.028a5.174 5.174 0 0110.17-.004l-.116-.024a.8.8 0 00-.957.785v4.448c0 .06.007.118.019.174a4.805 4.805 0 01-1.889 1.296 2.39 2.39 0 01.215 1.618 6.411 6.411 0 003.343-2.45l.383-.076A2.4 2.4 0 0016 10.033v-.865c0-.9-.5-1.701-1.258-2.112a6.773 6.773 0 00-13.508.014A2.4 2.4 0 000 9.168v.865a2.4 2.4 0 001.93 2.353l1.113.223A.8.8 0 004 11.824V7.376a.8.8 0 00-.957-.785z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6 14.4a1.6 1.6 0 11-3.199 0 1.6 1.6 0 013.199 0z",
    fill: "currentColor"
  }));
};

exports.Headphones = Headphones;
var _default = Headphones;
exports.default = _default;